import { useTranslation } from "react-i18next";

const WorkerCreated = () => {
    const {t} = useTranslation();

    return ( 
        <div className="m-4">
            <h3>{t("Thank you for registering!")}</h3>
            <p>{t("Your profile has been created. You may close out of this window.")}</p>
        </div>
     );
}
 
export default WorkerCreated;